<template>
  <div class="card pb-2 px-5 mb-5 pt-10">
    <ul class="nav fs-4 fw-bold mb-3 mb-md-0">
      <li
          v-for="(type, index) in types" :key="index"
          @click.prevent="() => toggleList(type.value)"
          :class="query.type === type.value ? 'active' : ''"
          class="nav-item cursor-pointer">
        <a
            :class="query.type === type.value ? 'active' : ''"
            class="mx-5"
        >
          {{ type[locale] }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script setup>
import { useLocales } from "@/composables/locales";
import {ref} from "vue";

const {locale} = useLocales()

const props = defineProps({
  types: { type: Array, default:  []},
  query: {type: Object, default: {type: ''}}
})

const formData = ref(props.query)

const toggleList = (type) => {
  formData.value.type = type
}


</script>
<style scoped>
li.nav-item a {
  color: var(--bs-gray-600);
}

li.nav-item a:hover, li.nav-item a:active, li.nav-item a.active {
  color: var(--bs-primary);
}

li.nav-item:active, li.nav-item.active {
  border-bottom: 2px solid var(--bs-primary);
}
</style>
